<div class="users-settings">
  <h1>{{ 'SETTINGS.USERS.TITLE' | translate }}</h1>

  <div class="actions">
    <orbit-button
      label="{{ 'SETTINGS.USERS.ADD_USER' | translate }}"
      (click)="addUser()"
      [icon]="addIcon"></orbit-button>
  </div>

  @let loadingValue = loading();
  @let errorValue = error();
  <!-- Loading indicator -->
  @if (loadingValue) {
    <div class="loading-container">
      <p>{{ 'SETTINGS.USERS.LOADING' | translate }}</p>
    </div>
  }

  <!-- Error message -->
  @if (errorValue) {
    <div class="error-container">
      <p class="error-message">{{ errorValue }}</p>
    </div>
  }

  <!-- Users table -->
  @let usersValue = users();
  @if (!loadingValue && !errorValue && usersValue && usersValue.length > 0) {
    <div class="users-table-container">
      <table class="users-table">
        <thead>
          <tr>
            <th>{{ 'SETTINGS.USERS.FIRSTNAME' | translate }}</th>
            <th>{{ 'SETTINGS.USERS.LASTNAME' | translate }}</th>
            <th>{{ 'SETTINGS.USERS.EMAIL' | translate }}</th>
            <th>{{ 'SETTINGS.USERS.ROLE' | translate }}</th>
            <th>{{ 'SETTINGS.USERS.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (user of usersValue; track user.id) {
            <tr>
              <td>{{ user.firstname || '-' }}</td>
              <td>{{ user.lastname || '-' }}</td>
              <td>{{ user.email }}</td>
              <td>{{ 'SETTINGS.USERS.ROLES.' + user.role | translate }}</td>
              <td class="actions-cell">
                <button
                  class="btn-icon"
                  title="{{ 'SETTINGS.USERS.EDIT_USER' | translate }}"
                  (click)="editUser(user)">
                  <fa-icon [icon]="editIcon" class="edit-icon"></fa-icon>
                </button>
                <button
                  class="btn-icon"
                  title="{{ 'SETTINGS.USERS.DELETE_USER' | translate }}"
                  (click)="deleteUser(user)">
                  <fa-icon [icon]="deleteIcon" class="delete-icon"></fa-icon>
                </button>
                <button
                  class="btn-icon"
                  title="{{ 'SETTINGS.USERS.UNLOCK_ALL_CONVERSATIONS.LABEL' | translate }}"
                  (click)="confirmUnlock(user)">
                  <fa-icon [icon]="unlockIcon"></fa-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- No users message -->
  @if (!loadingValue && !errorValue && usersValue && usersValue.length === 0) {
    <div class="empty-state">
      <p>{{ 'SETTINGS.USERS.NO_USERS' | translate }}</p>
    </div>
  }
</div>
